<div style="background:#0F1A41;color:white;text-align:center;vertical-align:middle;height:45px">
  <h2 mat-dialog-title style="padding-top:5px">Skapa transfer</h2>
</div>
<form [formGroup]="transferForm" (ngSubmit)="create()">
  <div class="flex-container">
    <mat-dialog-content style="padding:0px;margin:0px">
      <div style="margin-left:15px;margin-top:12px">
        <mat-form-field>
          <mat-label class="mat-input-header">Hållplats</mat-label>
          <mat-select placeholder="Hållplats" formControlName="transfer">
            <mat-option *ngFor="let tp of transferPoints" [value]="tp">
              {{tp.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <div style="display: flex;flex-direction:row-reverse;margin-right:15px;margin-bottom:15px">
      <button mat-flat-button style="background:#7AB800;margin-left:10px" type="submit" [disabled]="!canCreate()">Skapa</button>
      <button mat-button type="button" (click)="cancel()"
              style="margin-left:10px;background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px">Stäng</button>
    </div>
  </div>
</form>
